import {Component, Input} from '@angular/core';
import {CustomerProfile} from '../../../modules/customers/shared/api/entity';
import {PROFILE_STATE} from '../../../../../common/constants';
import {NavigationService} from '../../navigation';

@Component({
    selector: 'tfb-bo-card-box-private-content',
    template: `
        <!-- First column -->
        <div class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.NAME">{{ customer.name }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.ADDRESS">{{ customer.address }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.OPENING_DATE">{{ customer.opening_date }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.APPROVING_DATE">{{ customer.approvingDate }}</tfl-bo-data-item>
        </div>

        <!-- Second column -->
        <div class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.PRIVATE_EMAIL">{{ customer.email }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.PRIVATE_PHONE">{{ customer.phone }}</tfl-bo-data-item>
        </div>

        <!-- Third column -->
        <div *ngIf="customer.state == STATE.ACTIVE || customer.state == STATE.PENDING" class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.TARIFF">
                <a (click)="openTariffDetailView(customer.tariff.id)">{{ customer.tariff.name }}</a>
            </tfl-bo-data-item>

            <tfl-bo-data-item label="CUSTOMER.TABLE.MIN_TOTAL_ASSET">{{ customer.min_total_asset | money }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.INTRODUCER">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>
        </div>

        <div *ngIf="customer.state == STATE.NEW" class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.INTRODUCER_FROM_APPLICATION">{{ customer.applicationIntroducer}}</tfl-bo-data-item>
            <tfl-bo-data-item *ngIf="!customer.actualIntroducer.isSystem" label="CUSTOMER.TABLE.INTRODUCER">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>
        </div>
    `
})

export class CardBoxPrivateContentComponent {

    readonly STATE = PROFILE_STATE;

    @Input('customer') customer: CustomerProfile;

    constructor(private _navigation: NavigationService) {
    }

    openTariffDetailView(id: number) {
        this._navigation.configuration.tariff.detail(id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-content/card-box-private.content.component.ts